<section class="mb-4">
  <h2 class="h4">Find Existing People</h2>
  <div class="card">
    <div class="card-body">
      <p class="card-title">Find and select up to three people to merge.</p>
      <ness-find-person-container [excludePersons]="peopleMergeList" [suppressEdit]="true" (notifySelectedPeople)="updateSelectedPeople($event)"></ness-find-person-container>
      <p-messages [(value)]="findPeopleValidationMessages" [closable]="true"></p-messages>
      <button type="button" class="btn btn-sm btn-active" [disabled]="selectedPeopleToMerge.length === 0 || disableAddPeopleButton" (click)="addSelectedPeopleToMerge()">Add selected people to merge list</button>
    </div>
  </div>
</section>
<ness-merge-people [selectedPeopleToMerge]="peopleMergeList" (personRemoved)="personRemoved($event)"></ness-merge-people>
